'use client'

import * as React from 'react'
import { cn } from '../../helpers/index.js'
import { Text } from '../../components/text.js'
import { Heading } from '../../components/heading.js'
import type { BuyOneGetOneShelfProductCardSemanticName } from './types.js'

export interface ProductInfoProps extends React.HTMLAttributes<HTMLDivElement> {
  /** 产品名称 */
  name: string
  /** 产品描述 */
  description?: string
  classNames?: Partial<Record<BuyOneGetOneShelfProductCardSemanticName, string>>
  onClick?: () => void
}

/**
 * ProductInfo - 产品信息区域
 */
const ProductInfo = React.forwardRef<HTMLDivElement, ProductInfoProps>(
  ({ name, description, onClick, className, classNames = {} }, ref) => {
    return (
      <div ref={ref} className={cn('text-info-primary flex w-full flex-col gap-1', className)}>
        <Heading
          as="h4"
          size={2}
          html={name}
          className={cn('line-clamp-1 ', classNames?.productCardTitle)}
          onClick={() => onClick?.()}
        />
        <Text
          size={2}
          html={description}
          className={cn('desktop:text-[16px] lg-desktop:text-[18px] line-clamp-1', classNames?.productCardDescription)}
        />
      </div>
    )
  }
)

ProductInfo.displayName = 'ProductInfo'

export default ProductInfo
